import React from 'react';
import { FormattedMessage } from 'react-intl';
import Avatar from 'material-ui/Avatar';
import { ListComponent } from '../../List';
import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  TableHeader,
  TableHeaderColumn
} from 'material-ui/Table';

import ListActionItems from '../../List/ListActionItems';
import AddButton from './../../AddButton';
import LoadMore from '../../LoadMore';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';
import LoadingSpinner from '../../LoadingSpinner';

class PlayersList extends ListComponent {
  static contextTypes = {
    muiTheme: React.PropTypes.object
  };

  confirmRemoveMessage = (
    <FormattedMessage
      id="player.remove"
      defaultMessage="Are you sure want to delete player?"
    />
  );

  render() {
    let { add, list, items, hasMore, loading } = this.props;
    let {
      palette: { labelColor },
      tableHeaderColumn
    } = this.context.muiTheme;
    let records = list.map(id => items[id]);
    let fixedColumn = { style: { width: '120px', color: labelColor } };
    let iconBox = {
      style: { width: '120px', position: 'relative', left: '-12px' }
    };
    let numberHeaderStyle = {
      boxSizing: 'border-box',
      width: 120,
      color: labelColor
    };

    let flexRowStyle = {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      padding: '24px 0'
    };

    let nameStyle = {
      paddingLeft: '22px'
    };

    return (
      <div>
        <LoggedAppBar title="Player" isStatic />
        <LoadingSpinner show={loading}>
          <LoadMore active={hasMore} loadMore={() => this.loadMore()}>
            <Table selectable={false}>
              <TableHeader
                adjustForCheckbox={false}
                displaySelectAll={false}
                enableSelectAll={false}
                style={{
                  backgroundColor: tableHeaderColumn.bgColor
                }}
              >
                <TableRow>
                  <TableHeaderColumn style={numberHeaderStyle}>
                    #
                  </TableHeaderColumn>
                  <TableHeaderColumn style={{ color: labelColor }}>
                    Player
                  </TableHeaderColumn>
                  <TableHeaderColumn style={{ color: labelColor }}>
                    Position
                  </TableHeaderColumn>
                  <TableHeaderColumn {...fixedColumn}>
                    Options
                  </TableHeaderColumn>
                </TableRow>
              </TableHeader>

              <TableBody displayRowCheckbox={false}>
                {records.length > 0 ? (
                  records.map(({ id, name, position, number, photo }) => (
                    <TableRow key={id}>
                      <TableRowColumn style={numberHeaderStyle}>
                        <div>{number}</div>
                      </TableRowColumn>
                      <TableRowColumn>
                        <div style={flexRowStyle}>
                          <Avatar size={60} src={photo.medium} />
                          <div style={nameStyle}>{name}</div>
                        </div>
                      </TableRowColumn>
                      <TableRowColumn>{position}</TableRowColumn>

                      <TableRowColumn {...iconBox}>
                        <ListActionItems
                          edit={this.props.edit}
                          remove={this.props.delete}
                          record={items[id]}
                          confirmMessageLabel={this.confirmRemoveMessage}
                        />
                      </TableRowColumn>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableRowColumn columnNumber={6}>Empty list</TableRowColumn>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </LoadMore>
        </LoadingSpinner>
        <AddButton onClick={add} />
      </div>
    );
  }
}

export default PlayersList;



// WEBPACK FOOTER //
// ./src/components/Players/PlayersList/PlayersList.js